var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 37,
    viewBox: "0 0 49 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_757_65973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1177 36.1075V21.2814C28.1177 9.8393 35.602 2.08421 46.1373 2.4551e-06L48.1333 4.31485C43.2548 6.15432 40.1194 11.6126 40.1194 16.0478H48.1433V36.1075H28.1177ZM0 36.1075L1.2962e-06 21.2814C2.2965e-06 9.83929 7.51839 2.0822 18.0537 0L20.0517 4.31484C15.1711 6.15432 12.0358 11.6126 12.0358 16.0478H20.0256V36.1075H0Z",
    fill: "#4263EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_757_65973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/Quote.34f7a01b970ecacff8217971ceffd995.svg";
export { ForwardRef as ReactComponent };